import { useMemo } from 'react'

import { Select, type SelectProps } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useRichEditorStore } from '@eastcoal/editor/Store/hooks/useStore'

export const FontFamilySelect = (props: SelectProps) => {
  const { fontFamilyList, defaultFontFamily } = useRichEditorStore(state =>
    pick(state, ['fontFamilyList', 'defaultFontFamily'])
  )

  const options: SelectProps['options'] = useMemo(() => {
    return fontFamilyList.map(({ label, value }) => ({
      value,
      title: label,
      label: <span style={{ fontFamily: `${value}` }}>{label}</span>
    }))
  }, [fontFamilyList])

  return (
    <Select {...props} defaultValue={defaultFontFamily} options={options} />
  )
}
